<template>
  <div class="new-one-to-one-down" >

      <el-table :data="aloneData" stripe style="width: 100%">
      <el-table-column prop="date" label="公司名称"  v-if="lan=='ch'">
        <template slot-scope="scope">
           <img v-if="indexType == 'index'" class="table-img" style="margin-top: -20px;" :src="scope.row.company_logo_url || errorImage2"/>
           <img v-else class="table-img" :src="scope.row.company_logo_url || errorImage2"/>
           <div style="display: inline-block;" v-if="indexType == 'index'">
              <p style="font-size: 16px; font-weight: bold;padding-top:20px;">{{scope.row.company}}</p>
              <p style="font-size: 16px; padding-top: 5px;">所属展会：{{scope.row.exh_name}}</p>
           </div>
            <span v-else style="font-size: 16px; font-weight: bold;">{{scope.row.company}}</span>
        </template>
      </el-table-column>
      <el-table-column label="WIFFA" width="100" align="center" v-if="lan=='ch'">
        <template slot-scope="scope">
          <p style="font-weight:bold;color:#f08a00;font-weight: bold;" v-if="scope.row.is_wiffa == 1">WIFFA</p>
        </template>
      </el-table-column>
      <el-table-column prop="Broadcast_class" label="分类" width="160" align="center" v-if="lan=='ch'"></el-table-column>
      <el-table-column prop="Broadcast_state" label="状态"  :formatter="formatshow" width="160" align="center" v-if="lan=='ch'"></el-table-column>


          <el-table-column prop="date" label="Company" v-if="lan=='en'">
            <template slot-scope="scope">
              <!-- <img class="table-img" :src="scope.row.company_logo_url || errorImage1"/>
              <span style="font-size: 16px; font-weight: bold;">{{scope.row.company}}</span>
              <p style="font-size: 16px; padding-top: 5px;">Exhibition：{{scope.row.exh_name}}</p>
 -->          
              <div style="display:flex;">
                <div style="display: inline-flex;justify-content: center;align-items: center;">
                  <img v-if="indexType == 'index'" class="table-img" :src="scope.row.company_logo_url || errorImage2"/>
                  <img v-else class="table-img" :src="scope.row.company_logo_url || errorImage2"/>

                </div>
                <div style="flex:8">
                  <div style="display: inline-block;" v-if="indexType == 'index'">
                      <p style="font-size: 16px; font-weight: bold;">{{scope.row.company}}</p>
                      <p style="font-size: 16px; padding-top: 5px;">Exhibition：{{scope.row.exh_name_en}}</p>
                  </div>
                    <span v-else style="font-size: 16px; font-weight: bold;">{{scope.row.company}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="WIFFA" width="100" align="center" v-if="lan=='en'"> 
            <template slot-scope="scope">
              <p style="font-weight:bold;color:#f08a00;font-weight: bold;" v-if="scope.row.is_wiffa == 1">WIFFA</p>
            </template>
          </el-table-column>
          <el-table-column prop="broadcast_class_en" label="Classification" width="160" align="center" v-if="lan=='en'"></el-table-column>
          <el-table-column prop="broadcast_state" :formatter="formatshow" label="Status" width="160" align="center" v-if="lan=='en'"></el-table-column>

          <el-table-column width="200" :label="lan=='ch'?'点击查看展商预约该公司':'Reservation'" label-class-name="red_lebel">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="lan=='ch'?'点击查看展商预约该公司':'Click to reserve'" placement="top">
                <p class="new-one-item-seebtn" v-if="lan == 'ch'" @click="showParticipants(scope.row,scope.$index)">查看展商</p>
                <p class="new-one-item-seebtn" v-if="lan == 'en'" @click="showParticipants(scope.row,scope.$index)">Reservation</p>
              </el-tooltip>
            </template>
          </el-table-column>
  </el-table>



<!--    <div class="new-one-wrap" v-for="(item,index) in aloneData.broadCast" :key="index">-->
<!--      <div class="new-one-item">-->
<!--        <div class="new-one-item-img-wrap">-->
<!--          <img class="new-one-item-title-img" :src="item.new_broadcast_logo || errorImage" alt="">-->
<!--        </div>-->
<!--        <div class="new-one-item-title">-->
<!--          <p>-->
<!--            <span class="new-one-item-title-recommend" v-if="item.istop == 1 && lan == 'ch'">推荐</span>-->
<!--            {{item.broadcast_name}}-->
<!--          </p>-->
<!--        </div>-->
<!--        <div class="new-one-item-company">{{item.location }} - {{ item.company}}</div>-->
<!--        <div class="new-one-item-userpost">{{item.user_post}}: {{item.truename}}</div>-->
<!--        <div class="new-one-item-introduce">{{item.broadcast_introduce}}</div>-->
<!--        <div class="new-one-item-seebtn">-->
<!--          <p v-if="lan == 'ch'" @click="showParticipants(item)">查看展商</p>-->
<!--          <p v-if="lan == 'en'" @click="showParticipants(item)">Exhibitors</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>



<script>
  import {ExhibitionTypeEnum} from "../../../common/constant/exhibition";
  import errorImage from "../../../assets/error_room.png"
  import {stateEnum} from "./enum";
  import {mapGetters} from "vuex"
  export default {
    computed: {
      ...mapGetters(["token"])
    },
    props: {
      indexType: {
        type: String
      },
      language: {
          type: Object,
          default: () => {}
      },
      lan: {
        type: String
      },
      aloneData: {
        type: Array,
        default: () => []
      },
      exhState: {}
    },
    data() {
      return {
        errorImage1 :'https://yunzhan-1251180497.cos.ap-nanjing.myqcloud.com/ac4e3b819acaec2d4cffdc7ab66daff7447c8421.jpeg',
        errorImage2 :'https://yunzhan-1251180497.cos.ap-nanjing.myqcloud.com/bc59bdc4943a1afe6631ed5682ce58ef3ce54718.jpeg',
        ExhibitionTypeEnum,
        stateEnum,
        errorImage,
        isMobileBool: true,
        showHint: false,
        showBtn: false,
        showBtnShow: false
      }
    },
    methods: {
      wiffa(row, column){
        if(row.is_wiffa == 0){
          return ""
        }else{
          return "wiffa"
        }
      },
      formatshow(row, column){

        if(this.lan=="ch"){
          if(row.broadcast_state == 0||row.broadcast_state == 2){
            return "未开播"
          }else{
            return "开播"
          }
        }else{
          if(row.broadcast_state == 0||row.broadcast_state == 2){
            return "Not Started"
          }else{
            return "In Broadcast"
          }
        }
      },
      showParticipants(item,index) {
        // console.log(item);
        // return;
        this.$emit("showParticipants", item,index);
      },
    },
    mounted(){
    },
    created(){

    }
  }
</script>

<style scoped>
.new-one-to-one-down{
  border-top:2px solid rgb(17,92,175);
}

.new-one-to-one-down >>> .el-table td{
  border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
}

.new-one-to-one-down >>> .el-table th>.cell{
  margin: 10px 0;

}

.new-one-to-one-down >>> .el-table th>.cell{

      border-right: 0px solid #fff !important;
      text-align: center;
}
.table-img{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 20px;
  margin-left: 20px;
}


.new-one-item-seebtn{
  width: 60%;
  margin: 20px auto;
  text-align: center;
  background: #0f408a;
  color: #fff;
  padding: 6px 0;
  cursor: pointer;
}
.card-img{
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
}
.alone_content {
  padding: 20px 20px 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
}
  .alone_left {
    display: flex;
    flex-direction: column;
    display: -webkit-flex;
    align-items: center;
    overflow: hidden;
  }
  .alone_right {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    margin-left: 20px;
    width: 985px;
  }
  .always_main_title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 17px;
    color: #0f408a;
  }
  .broadcast_information {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin-top: 20px;
    font-size: 14px;
    color: #424242;
    font-weight: normal;
    font-stretch: normal;
    font-family: MicrosoftYaHei;
  }
  .profile {
    /* margin-top: 20px; */
    text-indent:2em;
    font-family: MicrosoftYaHeiLight;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0;
    color: #a1a1a1;
    word-wrap:break-word;
  }
  .info_col {
    max-width: 285px;
    display: inline-block;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .people_number{
    color: #424242;
    font-size: 14px;
  }
  .alone_btn{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-div{
    cursor: pointer;
    float: right;
    font-size: 14px;
    font-weight: 600;
    margin: 25px 0 25px;
    color: rgb(15, 64, 138);
  }
  .btn-div span{
    padding-top: 5px;
  }
  .btn-div img{
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-left: 2px;
    /* margin-top: -5px; */
  }
  .ellipsis-p{
    width: 985px;
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */

    position: relative;
    line-height: 24px;
    max-height:100%;
    overflow: hidden;
  }

  .ellipsis-p::after {
      content: "...";
      position: absolute;
      bottom: 0;
      right: 0px;
      padding:0 30px 0 0px;
      background: -webkit-linear-gradient(left, transparent, #fff 40%);
      background: -o-linear-gradient(right, transparent, #fff 40%);
      background: -moz-linear-gradient(right, transparent, #fff 40%);
      background: linear-gradient(to right, transparent, #fff 40%);
  }
  .ellipsis-p-m{
    width: 985px;
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */

    position: relative;
    line-height: 24px;
    max-height:100%;
    overflow: hidden;
  }
  .ellipsis-p-m::after {
      content: "...";
      position: absolute;
      bottom: 5px;
      right: 0px;
      padding:0 30px 0 0px;
      margin-left: -10px;
      font-size: 24px;
      background: #fff;
      /* background: -webkit-linear-gradient(left, transparent, #fff 40%);
      background: -o-linear-gradient(right, transparent, #fff 40%);
      background: -moz-linear-gradient(right, transparent, #fff 40%);
      background: linear-gradient(to right, transparent, #fff 40%); */
  }
  .new-one-wrap{
    width: 100%;
    /* display: inline-block; */
  }
  /* .new-one-wrap:nth-child(3n){
    margin-left: 20px;
    margin-right: 20px;
  } */


  .new-one-item{
    width: 100%;
    min-height: 400px;
    background: #fff;
    margin-top: 20px;
    padding: 20px 0 10px;
    /* float: left; */
    display: flex;
  }
  .new-one-item-img-wrap{
    width: 100%;
    min-height: 150px;
    text-align: center;
    margin: auto;
    position: relative;
  }
  .new-one-item-title-img{
    width: 150px;
    height: auto;
    max-height: 150px;
    vertical-align: middle;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    /* height: 150px; */
  }
  .new-one-item-title{
    width: 90%;
    margin: 20px auto 0;
    font-size: 1.1rem;
    font-weight: bold;
    min-height: 40px;
    overflow: hidden;
  }
  .new-one-item-title p{
    line-height: 1.5;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .new-one-item-title-recommend{
    font-size: 0.8rem;
    padding: 1px 10px;
    font-weight: 100;
    color: #fff;
    background: #0f408a;
    margin-right: 5px;
  }
  .new-one-item-company{
    width: 90%;
    margin: 5px auto;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    color: #a1a1a1;
  }
  .new-one-item-userpost{
    width: 90%;
    min-height: 38px;
    margin: 5px auto;
    padding-bottom: 10px;
    border-bottom: 1px solid #eceeec;
    color: #a1a1a1;
  }
  .new-one-item-introduce{
    width: 90%;
    min-height: 57px;
    margin:0 auto;
    padding-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: #a1a1a1;
  }
  .new-one-to-one-down >>> .red_lebel{
    color:red;
  }



</style>
